import { gql } from "@apollo/client";

export const SAVE_GOOGLE_MAPS_RUSH_HOURS = gql`
  mutation SaveGoogleMapsRushHours(
    $saveGoogleMapsRushHoursDto: SaveGoogleMapsRushHoursDto!
  ) {
    saveGoogleMapsRushHours(
      saveGoogleMapsRushHoursDto: $saveGoogleMapsRushHoursDto
    ) {
      id
      rules {
        date
        timeFrom
        timeTo
        marginMinutes
      }
    }
  }
`;
